import React, { useState } from 'react';
import { FiMail, FiSend } from 'react-icons/fi';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Validate form
    if (!formData.name || !formData.email || !formData.company || !formData.message) {
      setError('Please fill in all fields');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email address');
      return;
    }

    // Format email body
    const subject = `StoryCape Inquiry from ${formData.name} at ${formData.company}`;
    const body = `Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company}

Message:
${formData.message}`;

    // Create mailto link
    const mailtoLink = `mailto:sales@storycape.io?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Show success message
    setIsSubmitted(true);
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      company: '',
      message: ''
    });

    // Reset submission status after 5 seconds
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="section-title">Get in Touch</h2>
          <p className="section-description">
            Interested in StoryCape? Contact our sales team to learn more about how we can help your app engage users.
          </p>
        </div>

        <div className="contact-form-container">
          {isSubmitted ? (
            <div className="success-message">
              <div className="success-icon">
                <FiSend size={32} />
              </div>
              <h3 className="success-title">Thank You!</h3>
              <p className="success-text">
                Your message has been sent. Our team will get back to you soon.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Your name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="company" className="form-label">
                  Company
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Your company name"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  className="form-textarea"
                  placeholder="Tell us about your app and requirements"
                ></textarea>
              </div>
              
              <div className="form-submit">
                <button
                  type="submit"
                  className="submit-button"
                >
                  <FiMail className="button-icon" />
                  Contact Us
                </button>
              </div>
            </form>
          )}
        </div>

        <div className="direct-contact">
          <p>
            Prefer to email us directly? Reach out at{' '}
            <a href="mailto:sales@storycape.io" className="email-link">
              sales@storycape.io
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;